<template>
    <div class="group-rounded-box">
        <span class="title">Settlement Prices</span>

        <div class="row">
            <div class="col-md-12">
                <span class="float-right">{{ previousBusinessDay }}</span>
                <label>FX Settlement Price</label>
            </div>

            <!-- FX settlement -->
            <div class="form-group col-md-4 w-100">
                <label :class="{'error': errorIds.includes(rulesEnum.eTargetAttributeType.Fx)}">(GBP/USD)</label>
                <cleave :options="numeralFx" class="form-control text-center"
                    placeholder="0.0000"
                    v-model="rules.find(r => r.action.targetAttribute === rulesEnum.eTargetAttributeType.Fx).action.value"
                    @blur="validateInput(rulesEnum.eTargetAttributeType.Fx)"
                ></cleave>
                <div v-if="errorIds.includes(rulesEnum.eTargetAttributeType.Fx)" class="invalid-input">
                    <i class="fas fa-exclamation"></i>
                    Please enter a valid FX settlement
                </div>
            </div>
            
            <!-- Fuel settlement -->
            <div class="col-md-12">
                <label class="d-block">Fuel Settlement Prices ({{ rulesEnum.eUnitType.UsdPerMetricTonne.display }})</label>
            </div>

            <!-- Base product settlement prices -->
            <div class="form-group col-md-4" 
                v-for="(product, key) in baseProducts" :key="key">
                <label :class="{'error': errorIds.includes(product._id)}">{{product.name}}</label>
                <cleave :options="numeralPositive" class="form-control text-center" 
                    placeholder="0.00"
                    v-model="rules.find(r => r.targets[0] && r.targets[0].type === rulesEnum.eTargetType.Product && r.targets[0].ids.includes(product._id)).action.value"
                    @blur="validateInput(rulesEnum.eTargetAttributeType.ProductSettle, product._id)"
                ></cleave>
                <div v-if="errorIds.includes(product._id)" class="invalid-input">
                    <i class="fas fa-exclamation"></i>
                    Please enter a valid settlement for {{ product.name }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import breakpoint from '@/mixins/index';
import { mapGetters } from "vuex";
import momentBusiness from 'moment-business-days';
import { rulesEnum } from "@/util/enums/rules";

export default {
    mixins: [breakpoint],
    props: {
        rules: {
            type: Array,
            required: true
        },
        baseProducts: {
            type: Array,
            required: true
        },
        componentKey: {
            type: String,
            default: "SETTLEMENT"
        }
    },
    data(){
        return {
            errorIds: [],
            rulesEnum
        }
    },
    computed: {
        ...mapGetters('inputCheckers', ['numeralPositive', 'numeralFx']),
        previousBusinessDay: {
            get: function(){
                return momentBusiness().prevBusinessDay().format("DD/MM/YYYY");
            }
        },
    },
    watch: {
        errorIds: function(){  // Flag to the parent component whether there is error found or not
            let status = this.errorIds.length > 0;
            if (status == false){
                const productSettlePrices = this.rules.map(p => Number(p.action.value));
                status = productSettlePrices.includes(0);
            }
            this.$emit("errorFound", this.componentKey, status);
        }
    },
    methods: {
        validateInput: function(targetAttribute, productId){
            let value = 0;
            let isValueInvalid = false;
            const isInputFx = targetAttribute === rulesEnum.eTargetAttributeType.Fx;
            const inputId = isInputFx ? targetAttribute : productId;
            const errorIdIndex = this.errorIds.findIndex(id => id === inputId);

            if (isInputFx){
                // Assign value and set it to 4 decimal places
                value = this.rules.find(r => r.action.targetAttribute === rulesEnum.eTargetAttributeType.Fx).action.value;
                this.rules.find(r => r.action.targetAttribute === rulesEnum.eTargetAttributeType.Fx).action.value = Number(value).toFixed(4);
            } else {
                // Assign value and set it to 2 decimal places
                value = this.rules.find(r => r.targets[0] && r.targets[0].type === rulesEnum.eTargetType.Product && r.targets[0].ids.includes(productId)).action.value;
                this.rules.find(r => r.targets[0] && r.targets[0].type === rulesEnum.eTargetType.Product && r.targets[0].ids.includes(productId)).action.value = Number(value).toFixed(2);
            }

            isValueInvalid = value == 0;
            
            if (isValueInvalid){
                if (errorIdIndex == -1) // If this error ID has not existed already, then add it to the list of errors
                    this.errorIds.push(inputId);
            } else {
                if (errorIdIndex > -1) // If this error ID exists, then we can remove it from the list
                    this.errorIds.splice(errorIdIndex, 1);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.invalid-input .fa-exclamation { // Override the global styling for the error exclamation marks
    right: 1.7rem!important;
    top: 2.1rem!important;
}
</style>